import React from 'react';
import { observer } from 'mobx-react';

import PatientUpsertModal from './components/patient-upsert-modal';

import AdminTableLayout from 'components/admin-table-layout';
import Title from 'components/admin-table-layout/components/title';
import TableHeader from 'components/admin-table-layout/components/table-header';
import EntriesCount from 'components/admin-table-layout/components/table-header/components/entries-count';
import Paginator from 'components/paginator';
import NewEntryButton from 'components/admin-table-layout/components/table-header/components/new-entry-button';
import ListSearch from 'components/drill-down-layout/components/list/components/list-header/components/list-search';
import TableContent from 'components/admin-table-layout/components/table-content';
import SmartTable from 'components/smart-table';

import {
  COLUMNS,
  PATIENT_MANIPULATION_OPTIONS
} from './constants';
import { MAX_TABLE_ENTRIES_PER_PAGE } from 'models/patients/constants';

import './patients-style.scss';

const { CREATE, UPDATE } = PATIENT_MANIPULATION_OPTIONS;

const PatientsView = ({
  patientsStore,
  patientsRouteStore,
  patientUpsertModalRouteStore,
  sortPatients,
  changePaginationPage,
  onPatientsSearch,
  showPatientUpsertModal,
  closePatientUpsertModal,
  onHealthcareSitesSearch,
  addHealthcareSiteLocally,
  removeHealthcareSiteLocally,
  createPatient,
  updatePatient,
  deletePatient,
  showPatientDeleteConfirmationModal
}) => (
  <React.Fragment>
    <PatientUpsertModal
      patientUpsertModalRouteStore={patientUpsertModalRouteStore}
      patientsRouteStore={patientsRouteStore}
      createPatient={createPatient}
      updatePatient={updatePatient}
      deletePatient={deletePatient}
      closePatientUpsertModal={closePatientUpsertModal}
      onHealthcareSitesSearch={onHealthcareSitesSearch}
      addHealthcareSiteLocally={addHealthcareSiteLocally}
      removeHealthcareSiteLocally={removeHealthcareSiteLocally}
      showPatientDeleteConfirmationModal={showPatientDeleteConfirmationModal}
    />
    <AdminTableLayout>
      <Title
        text='Patients'
      />
      <TableHeader>
        <div className='left-area'>
          <EntriesCount
            count={patientsStore.entriesCount}
            caption='Patients'
          />
          <Paginator
            currentPage={patientsRouteStore.currentPage}
            entriesCount={patientsStore.entriesCount}
            entriesPerPage={MAX_TABLE_ENTRIES_PER_PAGE}
            changePage={changePaginationPage}
          />
        </div>
        <div className='right-area'>
          <NewEntryButton
            caption='New Patient'
            onClick={e => showPatientUpsertModal(e, CREATE)}
          />
          <ListSearch
            searchValue={patientsRouteStore.filterValue}
            onSearch={onPatientsSearch}
          />
        </div>
      </TableHeader>
      <TableContent>
        <SmartTable
          sortingFieldName={patientsRouteStore.sortingColumn.fieldName}
          sortingOrder={patientsRouteStore.sortingColumn.sortingOrder}
          onSortIconClick={sortPatients}
          rows={patientsRouteStore.forTable}
          onRowClick={content => showPatientUpsertModal(content, UPDATE)}
          columns={COLUMNS}
          loading={patientsRouteStore.loading}
        />
      </TableContent>
    </AdminTableLayout>
  </React.Fragment>
);

export default observer(PatientsView);
